import { picturesAPI } from '../services/api';

/**
 * For each event where userId is the organizer, checks whether a group photo already exists.
 * Returns a map of { [eventId]: boolean } so callers can disable the "Event Photo" button.
 * @param {Array} events - List of event objects (may include events from multiple sources)
 * @param {string|number} userId - The current user's ID
 * @returns {Promise<Object>} Map of { [eventId]: boolean }
 */
export const buildGroupPhotoExistsMap = async (events, userId) => {
  const organizerEvents = events.filter(e => e.organizer?.id === userId);
  if (organizerEvents.length === 0) return {};

  const checks = await Promise.all(
    organizerEvents.map(e =>
      picturesAPI.checkExists(userId, null, e.id).catch(() => false)
    )
  );

  const map = {};
  organizerEvents.forEach((e, i) => { map[e.id] = checks[i]; });
  return map;
};
